import { Row, Col } from "react-grid-system"
import BodyMedium from "../../atoms/typography/BodyMedium"
import ButtonTextSmall from "../../atoms/typography/ButtonTextSmall"

const ArticleMetadata: React.FunctionComponent<{ publishedAt?: Date; tags: string[] }> = ({ publishedAt, tags }) => {
  return (
    <Row justify="between">
      <Col xs={12} md="content">
        <BodyMedium>{publishedAt?.toLocaleDateString()}</BodyMedium>
      </Col>
      <Col xs="content">
        <Row align="center" nogutter wrap="nowrap" style={{ columnGap: "2rem" }}>
          {tags.map((tag) => (
            <ButtonTextSmall key={tag}>#{tag}</ButtonTextSmall>
          ))}
        </Row>
      </Col>
    </Row>
  )
}

export default ArticleMetadata
